import React from "react";

const Loading = () => {
  return (
    <div className="w-full flex items-center justify-center h-screen">
      {" "}
      <div className="loader"></div>
    </div>
  );
};

export default Loading;
